// extracted by mini-css-extract-plugin
module.exports = {"main_button":"Button_main_button__3AP4G","project_button":"Button_project_button__i7vXU"};